import React from "react";
import { Box, Select, MenuItem, Typography } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { LANG_VERSIONS } from "../constants";

const LangSwitch = ({ language, onSelect }) => {
  const languages = Object.entries(LANG_VERSIONS);

  const handleSelectChange = (event) => {
    onSelect(event.target.value);
  };

  return (
    <Box sx={{ ml: 2, mb: 4, marginTop: "5px", marginLeft: "5px", marginBottom: "5px" }}>
      <Select
        value={language}
        onChange={handleSelectChange}
        variant="outlined"
        displayEmpty
        sx={{
          color: 'white',          
          borderRadius: '4px',
          height: '35px',
          '.MuiOutlinedInput-notchedOutline': { border: 0 },
          '& .MuiSelect-icon': {
            color: 'white',
          },
          '&:hover': {backgroundColor: '#372D43'},
          '&:focus': {
            outline: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
          },
          '&.Mui-selected': {
            backgroundColor: '#372D43',
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#372D43',
          },
        }}
        IconComponent={ArrowDropDownIcon}
        renderValue={(selected) => {
          if (!selected) {
            return <Typography sx={{ color: 'white' }}>Select Language</Typography>;
          }
          return selected;
        }}

        MenuProps={{
          PaperProps: {
            sx: {
              
              
              '& .MuiList-root': {
                padding: '3px', 
                
                
              },
            },
          },
        }}
      >
        {languages.map(([lang, version]) => (
          <MenuItem 
          key={lang} 
          value={lang}
          sx={{
            backgroundColor: 'transparent',
            '&.Mui-selected': {
              backgroundColor: 'transparent !important', 
            },                  
            '&:hover': {
              backgroundColor: 'grey !important', 
              
            },
            borderRadius:'4px',
            marginTop:'3px',
            marginBottom:'3px'
          }}
          >
            {lang}
            <Typography component="span" sx={{ color: "gray.600", fontSize: "small", ml: 1 }}>
              ({version})
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default LangSwitch;
